// extracted by mini-css-extract-plugin
module.exports = {"stack_style":"IconFullscreen_stack_style__2ZvhI","inactive":"IconFullscreen_inactive__2mYc6"};